/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Op_LtInputs */

const cs_op_lt = /** @type {(inputs: Op_LtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<`)
};

const en_op_lt = /** @type {(inputs: Op_LtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<`)
};

/**
* | output |
* | --- |
* | "<" |
*
* @param {Op_LtInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const op_lt = /** @type {((inputs?: Op_LtInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Op_LtInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_op_lt(inputs)
	return cs_op_lt(inputs)
});